import * as ACTION_TYPES from './action-types';

const initialState = {
  timeWindow: 8,
  refresh: 0,
};

export default function mspReportReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ACTION_TYPES.SET_TIME_WINDOW: {
      return {
        ...state,
        timeWindow: payload,
      };
    }
    case ACTION_TYPES.SET_REFESH_TIMER: {
      return {
        ...state,
        refresh: payload,
      };
    }
    default:
      return state;
  }
}
